import { Select } from 'antd';
import React, { useState, useEffect } from 'react';
import { InputSelect } from './styles';

import api from '../../services/api';

export function SearchInputModelosVeiculos({
  codigoMarca,
  initialValue,
  onChangeCallBack,
  placeholder,
  disabled,
  style,
}) {
  const { Option } = Select;
  let timeout;
  let currentValue;

  const fetchValue = (search, marcaCodigo, callback) => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }

    currentValue = search;

    const searchCodigoModelo =
      !isNaN(search) && Number(search) === initialValue;

    const getModelo = () => {
      const queryParams = searchCodigoModelo
        ? `ModeloCodigo=${search}`
        : `ModeloDescricao=${search}`;
      try {
        api
          .get(
            `marca-modelo/list-modelos?MarcaCodigo=${marcaCodigo}&${queryParams}`
          )
          .then(response => response.data)
          .then(d => {
            if (currentValue === search) {
              const items = d.marcasModelos.map(x => x.modelo);
              const data = items.map(item => ({
                value: `${item.codigo}#${item.descricao}`,
                text: item.descricao,
              }));

              if (initialValue && String(initialValue) === items[0]?.codigo) {
                handleChange(data[0].value);
              }

              callback(data);
            }
          });
      } catch (e) {}
    };

    timeout = setTimeout(getModelo, 300);
  };

  const [data, setData] = useState([]);
  const [value, setValue] = useState();
  const [marcaCodigo, setMarcaCodigo] = useState('');

  const handleSearch = newValue => {
    if (newValue) {
      fetchValue(newValue, marcaCodigo, setData);
    } else {
      setData([]);
    }
  };

  const handleChange = newValue => {
    setValue(newValue);
    if (onChangeCallBack) onChangeCallBack(newValue);
  };

  useEffect(() => {
    setValue(null);
    setData([]);
    setMarcaCodigo(codigoMarca);
  }, [codigoMarca]);

  useEffect(() => {
    if (initialValue && marcaCodigo) {
      handleSearch(initialValue);
    }
  }, [initialValue, marcaCodigo]);

  const options = data.map(d => <Option key={d.value}>{d.text}</Option>);
  return (
    <InputSelect
      showSearch
      disabled={disabled}
      value={value}
      dropdownMatchSelectWidth={false}
      placeholder={placeholder}
      defaultActiveFirstOption={false}
      showArrow={false}
      filterOption={false}
      onSearch={handleSearch}
      onChange={handleChange}
      notFoundContent={null}
      allowClear={true}
    >
      {options}
    </InputSelect>
  );
}
